<template>
    <div class="add-place container">
        <form @submit.prevent="addPlace">
            <div class="field ">
                <label for="title">Name:</label>
                <input type = "text" name = "name" v-model="name">
            </div>
             <div class="field ">
                <label for="type">Type:</label>
                <input type = "text" name = "type" v-model="type">
            </div>
             <div class="field ">
                <label for="type">Description:</label>
                 <textarea name = "description" v-model = "description"></textarea> 
            </div>
             <div class="field ">
                <label for="location">Location:</label>
                <input type = "text" name = "location" v-model="location">
            </div>
            <div class="field ">
              <input type="file" ref ="fileInput" @change="onFileSelected">
            </div>  
               
            <p class = "red-text">{{feedback}}</p>
             <div class="field ">
               <button class = "btn orange">Add Place</button>
            </div>
        </form>

    </div>
</template>
<script>
import firebase from "firebase"
 import db from "@/firebase/init"
 import slugify from "slugify"
export default {
   
    name:"AddPlace",
    data(){
        return{
            name:null,
            type:null,
            location:null,
            slug:null,
            feedback:null,
            description:null,
            slug:null,
            imageUrl :null,
            imageName:null,
            ownerData:null,
            author:{
               name:null,
               id:null
            }
        }
       
    },
    methods:{
          onFileSelected(event){
            
            this.image = event.target.files[0]
            
        
        },
        addPlace(){
            var image
            if(this.name && this.type ){
                 this.slug = slugify(this.name,{
                replacement:"-",
                remove:/[$*_+~.()'"!\-:@]/g,
                lower:true
                })
                 var file = this.image
                 
                 var storage = firebase.storage();
                 var storageRef = firebase.storage().ref("places/"+ this.name  +".jpg" )
                 storageRef.put(file).then(function(snapshot) {
                console.log('Uploaded a blob or file!');
                 }).then(()=>{
                storageRef.getDownloadURL().then(function(url) {
                 image = url
                       }).then(()=> {

                    console.log(image)
                    let ref = db.collection("places").doc(this.slug)
                ref.set({
                  
                    name : this.name,
                    type : this.type,
                     slug:this.slug,
                    location : this.location,
                    description: this.description,
                    imageName : this.name,
                    author:{
                        name: authorName,
                        id : authorId
                    },
                    imageUrl:image

                   
                }).then(() => {
                   
                     
                    this.$router.push({name:"Index"})
                }).catch(err => {
                    console.log(err)
                })
                 }) })

            }else{
                this.feedback = "all fields must be filed"
            }
             
        }
    } ,
    created(){
        let user = firebase.auth().currentUser
        // console.log(user)
       db.collection("users").where("user_id", "==", user.uid).get()
                .then(snapshot => {
                       snapshot.forEach((doc) => {
                          
                           name = doc.data().firstName + " " +  doc.data().lastName
                           authorName = name
                           authorId = doc.data().user_id   
                            console.log(authorName) 
                       })
                
                   
                })
    }    
   
}
</script>




// WEBPACK FOOTER //
// src/components/AddPlace.vue